import type { AtomizedDrop } from "@anaconda/core/drop/utils"
import type { CollectionId } from "@anaconda/core/nft-collection/types"
import { toCollectionId } from "@anaconda/core/nft-collection/utils"
import type { Atom } from "@reatom/core"
import { atom } from "@reatom/core"
import { createScope } from "bunshi"

interface ScopeState {
  dropId: CollectionId
}

export const DropScope = createScope<Atom<AtomizedDrop>>(
  atom({} as AtomizedDrop, "defaultDropAtom"),
)

export const DropIdScope = createScope<ScopeState>({
  dropId: toCollectionId(""),
})

export const RefetchIntervalScope = createScope<number>(5000) // Default 5 seconds
